export enum ShopIntegrationSchema {
  Redirect = 'redirect',
  Host2Host = 'h2h',
}
